import { Stack } from '@mui/material';

import ClientSiblingSection from './ClientSiblingSection';
import FamilyAdditionalInfoSection from './FamilyAdditionalInfoSection';
import ParentAndCaregiverSection from './ParentAndCaregiverSection';

import type { FamilyFieldsProps } from './types';

export default function FamilyFields({
  familyMembers,
  siblings,
  additionalInfo,
  culturalConsideration,
  disabled,
  hasSavedValues,
  showListErrors,
  isSavingMember,
  isSavingSibling,
  isSavingAdditionalInfo,
  onCreateMember,
  onUpdateMember,
  onDeleteMember,
  onCreateSibling,
  onUpdateSibling,
  onDeleteSibling,
  onCreateAdditionalInfo,
  onDeleteAdditionalInfo,
  onSaveCulturalConsideration,
  richTextCulturalConsideration = false,
}: FamilyFieldsProps) {
  return (
    <Stack gap={4}>
      <ParentAndCaregiverSection
        disabled={disabled}
        familyMembers={familyMembers}
        isSaving={isSavingMember}
        onCreate={onCreateMember}
        onDelete={onDeleteMember}
        onUpdate={onUpdateMember}
      />
      <ClientSiblingSection
        disabled={disabled}
        isSaving={isSavingSibling}
        onCreate={onCreateSibling}
        onDelete={onDeleteSibling}
        onUpdate={onUpdateSibling}
        siblings={siblings}
      />
      <FamilyAdditionalInfoSection
        additionalInfo={additionalInfo}
        culturalConsideration={culturalConsideration}
        disabled={disabled}
        hasSavedValues={hasSavedValues}
        isSaving={isSavingAdditionalInfo}
        onCreate={onCreateAdditionalInfo}
        onDelete={onDeleteAdditionalInfo}
        onSaveCulturalConsideration={onSaveCulturalConsideration}
        richTextCulturalConsideration={richTextCulturalConsideration}
        showListErrors={showListErrors}
      />
    </Stack>
  );
}
